import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined'
import { styled, Tooltip, IconButton } from '@mui/material'
import { useParams } from 'react-router-dom'
import { activeAlbumIdVar, drawerVar } from '../../../../../providers/apollo/cache'
import useSelectedAlbums from '../../../hooks/useSelectedAlbums'
import useBucket from '../../../hooks/useBucket'
import useBucketMigrationProgress from '../../../hooks/useBucketMigrationProgress'
import useBucketConvertProgress from '../../../hooks/useBucketConvertProgress'

const PillButton = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#fff',
  fontWeight: 500,
  fontSize: '0.875rem',
  cursor: 'pointer',
  gap: 8
})

export default function AlbumOrganizeActionPill() {
  const { bucketId, albumId } = useParams<{ bucketId: string; albumId: string }>()
  const { selectedAlbums } = useSelectedAlbums()
  const containRootAlbum = Array.from(selectedAlbums.keys()).includes(bucketId as string)
  const { bucketUser } = useBucket()
  const albumMovePermission = bucketUser?.permissions?.albumUpdate
  const isMigrationInProgressForBucket = useBucketMigrationProgress()
  const isBucketConvertInProgressForBucket = useBucketConvertProgress()

  let title = 'Move Album'
  if (isMigrationInProgressForBucket || isBucketConvertInProgressForBucket) {
    title = 'Move album is disabled during the migration process'
  } else if (!albumMovePermission) {
    title = 'Your role for this bucket does not allow you to move albums.'
  }

  const disabled =
    containRootAlbum ||
    !(albumId || selectedAlbums.size === 1) ||
    !albumMovePermission ||
    isMigrationInProgressForBucket ||
    isBucketConvertInProgressForBucket

  const handleClick = () => {
    if (!albumId && selectedAlbums.size < 1) return

    if (albumId) {
      activeAlbumIdVar(albumId)
    } else if (selectedAlbums.size > 0) {
      const firstAlbumId = Array.from(selectedAlbums.keys())[0]
      activeAlbumIdVar(firstAlbumId)
    }
    drawerVar('bucketAlbumMove')
  }

  if (disabled) {
    return null
  }

  return (
    <Tooltip title={title} arrow>
      <PillButton as="span">
        <IconButton
          color="primary"
          aria-label="Move Album"
          disabled={disabled}
          onClick={handleClick}
          id="move-album-pill"
          data-test="move-album-pill"
          sx={{ color: '#fff' }}
        >
          <DriveFileMoveOutlinedIcon />
        </IconButton>
        <span style={{ color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#fff' }}>Organize</span>
      </PillButton>
    </Tooltip>
  )
}
